import type { ComputedRef, InjectionKey } from 'vue'

export const GALLERY_TOOLBAR_HEIGHT = 56

export const GALLERY_EMIT_ERROR_INJECTION = Symbol('emit_error') as InjectionKey<(e: unknown) => void>

export const GALLERY_IS_COMPARE_ACTIVE_INJECTION = Symbol('is_compare_active') as InjectionKey<Readonly<ComputedRef<boolean>>>
